import { render, staticRenderFns } from "./TehtavaStatusBagde.vue?vue&type=template&id=f27aa3e4"
import script from "./TehtavaStatusBagde.vue?vue&type=script&lang=js"
export * from "./TehtavaStatusBagde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports